<template>
  <fragment>
    <default-header :h2="title"></default-header>
    <back-btn></back-btn>
    <privacy-modal
      :contentType="modalContentType"
      v-if="showModal"
      @closeModal="closeModalFunc"
    ></privacy-modal>
    <div class="innerContent noBottomPadding">
      <form @submit.prevent="submit" class="mb-4">
        <div v-if="registerError" class="alert alert-danger">{{$t('register.somethingWrong')}}</div>

        <h3 class="text-center mb-3">{{$t('register.selectCountry')}}</h3>

        <div class="mb-4">
          <slick
            v-if="countries.length > 0"
            ref="slick"
            :options="slickOptions"
            @afterChange="handleAfterChange"
          >
            <a class="lang" v-for="(country, idx) in countries" :key="idx">
              <div
                class="img"
                :class="currentCountry === null ? 'non-selected' : ''"
                :style="{backgroundImage: 'url(' + require(`@/assets/flags/${country.country}.png`) + ')'}"
              ></div>
            </a>
          </slick>
          <span v-if="!currentCountry" class="text-center d-block select-country-flag">{{$t('general.selectCountryFlag')}}</span>
          <span
            v-if="currentCountry === null && countryError"
            class="vv-error mt-2 w-100 text-center d-block"
          >{{$t('register.countryFieldIsRequired')}}</span>
        </div>

        <div class="additionalPadding">
          <template v-if="currentCountry">
            <h3 class="text-center">{{$t('register.selectLanguage')}}</h3>
            <div v-for="(language, idx) in currentCountry.languages" class="mb-2" :key="idx">
              <div class="icheck-material-exide">
                <input
                  @change="setLanguage"
                  v-model="currentLanguage"
                  name="register-language"
                  type="radio"
                  :id="'lang'+idx"
                  :value="language"
                />
                <label :for="'lang'+idx">{{language}}</label>
              </div>
            </div>
            <span
              v-if="currentLanguage === null && languageError"
              class="vv-error pl-1"
            >{{$t('register.langRequired')}}</span>
          </template>

          <div style="padding: 2px;">
            <h3 class="text-center mt-3 mb-3">{{$t('register.personalDetails')}}</h3>

            <input-standard
              :label="$t('general.name')"
              :name="'name'"
              v-validate="'required'"
              :data-vv-as="$t('general.name')"
              @changedValue="inputChangedValue"
              :error="errors.first('name') ? $t('general.nameFieldIsRequired')  : false"
            />

            <input-standard
              :label="$t('general.lastName')"
              :name="'lastName'"
              v-validate="'required'"
              :data-vv-as="$t('general.lastName')"
              @changedValue="inputChangedValue"
              :error="errors.first('lastName') ?  $t('general.lastNameFieldIsRequired')  : false"
            />

            <input-standard
              :label="$t('general.enterEmail')"
              :name="'email'"
              v-validate="'required|email'"
              :data-vv-as="$t('general.enterEmail')"
              ref="email"
              @changedValue="inputChangedValue"
              :error="errors.first('email') ?  $t('general.emailFieldIsRequired')  : false"
            />

            <input-standard
              :label="$t('general.confirmEmail')"
              :name="'confirmEmail'"
              v-validate="'required|email|confirmed:email'"
              :data-vv-as="$t('general.confirmEmail')"
              @changedValue="inputChangedValue"
              :error="errors.first('confirmEmail') ? errors.first('confirmEmail')  : false"
            />

            <input-standard
              :label="$t('general.telephone')"
              :name="'telephone'"
              v-validate="'required'"
              :data-vv-as="$t('general.telephone')"
              @changedValue="inputChangedValue"
              :error="errors.first('telephone') ?  $t('general.phoneFieldIsRequired') : false"
            />

            <h3 class="text-center mt-3 mb-3">{{$t('myAccount.GarageDetails')}}</h3>

            <input-standard
              :label="$t('myAccount.companyName')"
              :name="'companyName'"
              v-validate="'required'"
              :data-vv-as="$t('myAccount.companyName')"
              @changedValue="inputChangedValue"
              :error="errors.first('companyName') ? $t('general.companyNameFieldIsRequired') : false"
            />

            <input-standard
              :label="$t('myAccount.street')"
              :name="'street'"
              v-validate="'required'"
              :data-vv-as="$t('myAccount.street')"
              @changedValue="inputChangedValue"
              :error="errors.first('street') ? $t('general.streetFieldIsRequired')  : false"
            />

            <div class="row" style="flex-wrap: nowrap; margin: auto;">
              <input-standard
                class="mr-1"
                :label="$t('general.number')"
                :name="'streetNumber'"
                v-validate="'required'"
                :data-vv-as="$t('general.number')"
                @changedValue="inputChangedValue"
                :error="errors.first('streetNumber') ? $t('general.streetNumberFieldIsRequired')   : false"
              />

              <input-standard
                class="ml-1"
                :label="$t('general.postCode')"
                :name="'zip'"
                v-validate="'required'"
                :data-vv-as="$t('general.postCode')"
                @changedValue="inputChangedValue"
                :error="errors.first('zip') ? $t('general.zipFieldIsRequired')   : false"
              />
            </div>

            <input-standard
              :label="$t('general.city')"
              :name="'city'"
              v-validate="'required'"
              :data-vv-as="$t('general.city')"
              @changedValue="inputChangedValue"
              :error="errors.first('city') ? $t('general.cityFieldIsRequired')   : false"
            />
            <select-standard
              v-if="currentCountry && currentCountry.hasOwnProperty('brands')"
              :list="currentCountry.brands"
              :name="'brand'"
              :chosen="register.brand"
              :label="'Brand of battery'"
              @selected="selectBrand"
              :error="brandError ? $t('general.brandFieldIsRequired')  : false"
            />

            <input-standard
                :label="$t('Promo')"
                :name="'promo'"
                v-validate="null"
                :data-vv-as="$t('Promo')"
                @changedValue="inputChangedValue"
                :error="false"
            />

            <h3 class="text-center mt-4">{{$t('myAccount.doYouHaveEbtTester')}}</h3>

            <div class="mb-2">
              <div class="icheck-material-exide">
                <input
                  @change="register.hasTester = true"
                  type="radio"
                  id="tester-yes"
                  name="have-tester"
                  :checked="register.hasTester"
                />
                <label for="tester-yes">{{$t('general.yes')}}</label>
              </div>
            </div>
            <div class="mb-2">
              <div class="icheck-material-exide">
                <input
                  @change="register.hasTester = false"
                  type="radio"
                  id="tester-no"
                  name="have-tester"
                  :checked="!register.hasTester"
                />
                <label for="tester-no">{{$t('general.no')}}</label>
              </div>
            </div>

            <div class="mt-4 mb-4">
              <div class="icheck-material-exide">
                <input
                  type="checkbox"
                  id="register-privacy-policy"
                  v-validate="'required'"
                  :data-vv-as="$t('register.privacyPolicy')"
                  name="register-privacy-policy"
                  v-model="privacyCheckBox"
                />
                <label for="register-privacy-policy">
                  {{ $i18n.locale ==='Dutch' ? 'Ik heb het gelezen' : $t('register.iRead')}}
                  <span
                    class="modalLink"
                    @click.capture.stop="showModalFunc('privacy')"
                  >{{$t('register.privacyPolicy')}}</span>
                  {{ $i18n.locale ==='Dutch' ? ' gelezen' : ''}}
                </label>
              </div>
              <span
                v-if="errors.first('register-privacy-policy')"
                class="vv-error pl-0"
              >{{ $t('register.privacyPolicyFieldIsRequired') }}</span>
            </div>
            <!-- TERMS FROM HERE -->
            <div class="mt-4 mb-4">
              <div class="icheck-material-exide">
                <input
                  type="checkbox"
                  id="register-terms-policy"
                  v-validate="'required'"
                  :data-vv-as="$t('register.privacyPolicy')"
                  name="register-terms-policy"
                  v-model="termsCheckBox"
                />
                <label for="register-terms-policy">
                  <!-- TODO Refactor: Check why dutch translation file is not used -->
                  {{ $i18n.locale === 'Dutch' ? 'Ik aanvaard de ' : $t('register.iRead')}}
                  <span
                    class="modalLink"
                    @click.capture.stop="showModalFunc('terms')"
                  >{{ $i18n.locale === 'Dutch' ? 'algemene voorwaarden' : $t('register.termsAndConditions')}}</span>
                </label>
              </div>
              <span
                v-if="errors.first('register-terms-policy')"
                class="vv-error pl-0"
              >{{ $t('register.termsAndConditionFieldIsRequired') }}</span>
            </div>

            <div class="mt-4 mb-4">
              <div class="icheck-material-exide">
                <input
                  type="checkbox"
                  id="register-gdpr"
                  v-validate="'required'"
                  :data-vv-as="$t('register.gdprCheckbox')"
                  name="register-gdpr"
                  v-model="gdprCheckbox"
                />
                <label for="register-gdpr">
                  {{ $t('register.iFollow') }}
                  <span
                    class="modalLink"
                    @click.capture.stop="showModalFunc('gdpr')"
                  >{{ $t('register.gdprRegulations') }}</span>
                </label>
              </div>
              <span
                v-if="errors.first('register-gdpr')"
                class="vv-error pl-0"
              >{{ $t('register.gdprRequired') }}</span>
            </div>

            <button
              type="submit"
              class="btn btn-primary mb-2 fw"
            >{{$t('register.createNewAccount')}}</button>
          </div>
        </div>
      </form>
    </div>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';
import SelectStandard from '../components/SelectStandard';
import InputStandard from '../components/InputStandard';
import Slick from 'vue-slick';
import PrivacyModal from '../components/PrivacyModal';
import BackBtn from '../components/BackBtn';
import { i18n } from '../translations/index';

export default {
  name: 'Register',
  components: {
    DefaultHeader,
    Slick,
    SelectStandard,
    InputStandard,
    PrivacyModal,
    BackBtn
  },
  data() {
    return {
      showModal: false,
      brandError: false,
      privacyCheckBox: false,
      termsCheckBox: false,
      gdprCheckbox: false,
      title: this.$i18n.t('register.title'),
      modalContentType: '',
      showTermsContent: false,
      register: {
        name: null,
        lastName: null,
        email: null,
        confirmEmail: null,
        telephone: null,
        companyName: null,
        street: null,
        streetNumber: null,
        zip: null,
        city: null,
        brand: null,
        country: null,
        language: null,
        hasTester: true,
        promo: null
      },
      currentCountry: null,
      currentLanguage: null,
      slickOptions: {
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        focusOnSelect: true,
        swipeToSlide: true,
        touchThreshold: 10,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 5
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 5
            }
          },
          {
            breakpoint: 320,
            settings: {
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          }
        ]
      },
      languageError: false,
      countryError: false,
      registerError: false
    };
  },
  beforeMount() {
    this.getConfigFromBackend();
  },
  mounted() {
    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');
  },
  destroyed() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      registerDataErrors: 'getRegisterDataErrors'
    })
  },
  methods: {
    ...mapActions(['getConfigFromBackend', 'setRegisterDataAction', 'setMessage']),
    submit() {
      this.languageError = this.currentLanguage == null;
      this.countryError = this.currentCountry == null;

      this.$validator.validate().then(valid => {
        if (valid && !this.validateBrand() && !this.languageError && !this.countryError) {
          this.setRegisterDataAction(this.register);
        }
      });
    },
    setLanguage() {
      if (this.currentLanguage) {
        i18n.locale = this.currentLanguage;
      }
    },
    validateBrand() {
      if (this.register.brand !== null) {
        this.brandError = false;
        return false;
      } else {
        this.brandError = true;
        return true;
      }
    },
    showModalFunc(name) {
      this.showModal = true
      this.modalContentType = name

      switch (name) {
        case 'privacy':
          this.title = this.$i18n.t('register.privacyPolicyTitle')
          break
        case 'terms':
          this.title = this.$i18n.t('register.termsAndConditionsTitle')
          break
        case 'gdpr':
          this.title = this.$i18n.t('register.gdprRegulations')
          break
      }
    },
    closeModalFunc() {
      this.showModal = false
      this.title = this.$i18n.t('register.title')
    },

    inputChangedValue(name, val) {
      this.register[name] = val;
    },

    selectBrand(name, brand) {
      this.register.brand = brand;
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentCountry = this.countries[currentSlide];
      this.currentLanguage = null;
    }
  },
  watch: {
    currentLanguage(newValue) {
      this.register.language = newValue;
    },
    currentCountry(newValue) {
      this.register.country = newValue;
    },
    registerDataErrors(newValue) {
      if (newValue !== false) {
        let errorFields = Object.entries(newValue);
        errorFields.map(error => {
          const fieldName = error[0].replace('register.', 'register-');
          const message = error[1].join();
          const field = this.$validator.fields.find({
            name: fieldName,
            scope: this.$options.scope
          });

          if (!field) {
            return;
          }

          this.$validator.errors.add({
            id: field.id,
            field: fieldName,
            msg: message.replace(error[0], field.el.dataset.vvAs),
            scope: this.$options.scope
          });

          field.setFlags({
            invalid: true,
            valid: false,
            validated: true
          });
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.modalLink {
  color: $primary;
  text-decoration: underline;
}
.lang {
  display: block;
  text-align: center;
}

.select-country-flag {
  font-size: 0.8em;
}

.img {
  border: 1px $gray-light solid;
  margin: 0 auto;
  display: block;
  overflow: hidden;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
  background-position: 50% 50%;
  background-size: 160%;
}

.select-brand {
  .btn,
  .dropdown-menu {
    width: 100%;
  }
}

.slick-slide {
  opacity: 0.5;
  transition: opacity 0.5s;

  .non-selected {
    opacity: 0.5;
  }

  &.slick-current {
    opacity: 1;
  }
}
</style>
